export default __webpack_public_path__ + "static/media/Sagittarius.e9cad8e3.svg";